// import ProjectCard from "../src/components/ProjectCard";
import { collection, getDocs, query } from "firebase/firestore";
import { db } from "../api_config/firebase-configuration";
import Head from "next/head";
import { useContext } from "react";
import { LocalizationContext } from "../src/lib/context";
import { GetStaticProps } from "next";
import BottomInfo from "../src/components/BottomInfo";
import InspirationsInfoSection from "src/components/Inspirations/InspirationsInfoSection";
import InspirationsCategories from "src/components/Inspirations/InspirationsCategories";
import InspirationsMain from "src/components/Inspirations/InspirationsMain";
import InspirationsCommunities from "src/components/Inspirations/InspirationsCommunities";

export const getStaticProps: GetStaticProps = async () => {
  const projects: any = [];
  const querySnapshot = await getDocs(query(collection(db, "projects")));
  querySnapshot.forEach((doc) => {
    projects.push({ ...doc.data(), id: doc.id });
  });

  return {
    props: {
      projects,
    },
    revalidate: 7200,
  };
};

export default function Inspirations({ projects }: { projects: any }) {
  const { localeStrings } = useContext(LocalizationContext);
  const localizedPageContent = localeStrings.inspirationsPage;

  const bottomInfoTexts = [
    localizedPageContent.aboutBody1,
    localizedPageContent.aboutBody2,
    localizedPageContent.aboutBody3,
    localizedPageContent.aboutBody4,
    localizedPageContent.aboutBody5,
  ];

  return (
    <div className="inspire">
      <Head>
        <title>{localizedPageContent.title}</title>
        <meta name="description" content={localizedPageContent.description} />
      </Head>
      <InspirationsInfoSection />

      <InspirationsCategories />

      <InspirationsMain />

      <InspirationsCommunities />

      <BottomInfo
        headerText={localizedPageContent.aboutTitle}
        textsArray={bottomInfoTexts}
        sendEmail={true}
        email={localeStrings?.errorPage?.mailToLink}
      />
    </div>
  );
}
